import React from "react";
import { useNavigate } from "react-router-dom";
import { PartyPopper, ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export default function Welcome() {
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    localStorage.removeItem("fisbo_new_signup");
  }, []);

  return (
    <div className="grid min-h-screen place-items-center bg-[#FAF9F6] px-4 py-10">
      <div className="w-full max-w-lg">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <div className="fade-up rounded-2xl border border-[#E5E2DC] bg-white p-8 text-center sm:p-10" data-testid="welcome-screen">
          <span className="mx-auto mb-5 grid h-14 w-14 place-items-center rounded-2xl" style={{ backgroundColor: "var(--tenant-primary-light)" }}>
            <PartyPopper className="tenant-text" strokeWidth={1.5} />
          </span>
          <h1 className="font-head text-3xl font-semibold tracking-tight text-neutral-900">You're in{user?.name ? `, ${user.name.split(" ")[0]}` : ""}!</h1>
          <p className="mt-2 text-lg font-medium text-neutral-800">What's next:</p>
          <p className="mx-auto mt-3 max-w-md leading-relaxed text-neutral-600">
            Your personalized Action Roadmap is ready. Start with your first recommended step — we'll walk you through it one move at a time.
          </p>
          <div>
            <button data-testid="welcome-start-btn" onClick={() => navigate("/dashboard")} className="mt-7 inline-flex items-center gap-2 rounded-full px-8 py-3.5 font-semibold text-white transition-all hover:-translate-y-0.5" style={{ backgroundColor: "var(--tenant-primary)" }}>
              Start Here <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
